(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MEUPCommon", [], factory);
	else if(typeof exports === 'object')
		exports["MEUPCommon"] = factory();
	else
		root["MEUPCommon"] = factory();
})((typeof self !== 'undefined' ? self : this), () => {
return 